import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
import { ArrowLeftIcon } from "../../icons/ArrowLeftIcon";
import * as Styled from "./Select.styled";
export const BackIcon = styled(ArrowLeftIcon) `
  pointer-events: none; // prevent issues with click in iOS VoiceOVer
`;
export const BackOptionItem = styled(Styled.Item).attrs({
    as: "button",
    type: "button"
}) `
  color: ${color("typeBody")};
  ${typeStyle("bodyM")}
  padding: ${`${units(1)} ${units(2)} ${units(1)}`};
  overflow: hidden; // to prevent issues with click in iOS VoiceOver

  ${BackIcon} {
    justify-self: center;
    transform: translateY(1px);
    color: ${color("brandPrimary", { palette: "interactiveNavigational" })};
  }
`;
